var React = require('react');

function Xing (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M13.3,0C6,0,0.1,5.8,0.1,12.9S6,25.8,13.3,25.8S26.5,20,26.5,12.9S20.6,0,13.3,0z M9,16.1H6.6\n\t\tc-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.1-0.1-0.2,0-0.4l2.5-4.4c0,0,0,0,0,0L7.2,8.5c-0.1-0.1-0.1-0.3,0-0.4C7.3,8.1,7.4,8,7.5,8h2.4\n\t\tc0.4,0,0.5,0.2,0.7,0.4c0,0,1.6,2.8,1.6,2.8c-0.1,0.2-2.6,4.4-2.6,4.4C9.5,15.9,9.4,16.1,9,16.1L9,16.1z M20.3,5.3L15,14.4\n\t\tc0,0,0,0,0,0l3.4,6c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.3,0.1h-2.4c-0.4,0-0.5-0.2-0.7-0.4c0,0-3.4-6-3.4-6.1\n\t\tc0.2-0.3,5.3-9.2,5.3-9.2c0.1-0.2,0.3-0.4,0.6-0.4H20c0.1,0,0.3,0.1,0.3,0.1C20.4,5.1,20.4,5.2,20.3,5.3L20.3,5.3z","fill":"white","fillOpacity":"0.66","fillRule":"evenodd","clipRule":"evenodd"}));
}

Xing.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26","fill":"none"};

module.exports = Xing;

Xing.default = Xing;
